
export const commonUtils = {
  methods: {
    checkFileSize(file, limitSize) {
      const isLt5M = file.size / 1024 / 1024
      if (isLt5M === 0) {
        this.$message({
          message: `上传文件大小需大于0B!`,
          type: 'warning'
        })
        return false
      }
      if (isLt5M > limitSize) {
        this.$message({
          message: `上传文件大小不能超过${limitSize}MB!`,
          type: 'warning'
        })
        return false
      }
      return true
    },
    checkFileType(file, allowType) {
      var type = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (allowType.includes(type)) {
        return true
      } else {
        this.$message({
          message: `仅支持${allowType}等!`,
          type: 'warning'
        })
        return false
      }
    },
    // 金额格式化
    fmoney (s, n) {
      n = n > 0 && n <= 20 ? n : 2
      s = parseFloat((s + '').replace(/[^\d.-]/g, '')).toFixed(n) + ''
      var l = s.split('.')[0].split('').reverse()
      var r = s.split('.')[1]
      let t = ''
      for (var index = 0; index < l.length; index++) {
        t += l[index] + ((index + 1) % 3 === 0 && (index + 1) !== l.length ? ',' : '')
      }
      return t.split('').reverse().join('') + '.' + r
    }
  },
  filters: {
    // 提交状态
    filterStatus (val) {
      switch (val) {
        case 'pending':
          return '未提交'
        case 'commit':
          return '已提交'
        case 'approval':
          return '审核通过'
        case 'reject':
          return '已驳回'
        case 'credit':
          return '已提交授信'
        default:
          return val
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/commonUtils.js